import React from "react";
import checkIcon from "../../assets/images/common/toast-check.svg"
import { MdOutlineReportGmailerrorred } from "react-icons/md";
import "../../assets/css/common/toaster.css";

const ShowToastMsg = (props) => {

    const succeddedStyles = { backgroundColor: '#3bbb70', color: '#fff' }
    const notSucceddedStyles = { backgroundColor: '#fdeded', color: 'red' }

    return (
        <>
            <div className={'toaster'} style={props.succeeded ? succeddedStyles : notSucceddedStyles}>
                {props.succeeded ? <img src={checkIcon} alt="icon" /> : <MdOutlineReportGmailerrorred size={20} />}
                <div
                    dangerouslySetInnerHTML={{ __html: props?.data }}
                />

            </div>

        </>
    );
};

export default ShowToastMsg;